/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 2532×1170 6.1-inch phone is about 460 PPI.`)
};

const es_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un móvil de 6,1 pulgadas a 2532×1170 tiene unos 460 PPI.`)
};

const de_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 6,1-Zoll-Smartphone mit 2532×1170 hat etwa 460 PPI.`)
};

const nl_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een telefoon van 6,1 inch met 2532×1170 heeft ongeveer 460 PPI.`)
};

const fr_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un téléphone de 6,1 pouces en 2532×1170 fait environ 460 PPP.`)
};

const it_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno smartphone da 6,1 pollici con risoluzione 2532×1170 ha circa 460 PPI.`)
};

const pt_br2_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um celular de 6,1 polegadas com resolução 2532×1170 tem cerca de 460 PPI.`)
};

const pt_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um telemóvel de 6,1 polegadas com 2532×1170 tem cerca de 460 PPI.`)
};

const ja_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2532×1170の6.1インチスマートフォンは約460PPIです。`)
};

const zh_ppi_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一台分辨率 2532×1170、屏幕尺寸 6.1 英寸的手机，PPI 约为 460。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_ex2", locale)
	if (locale === "en") return en_ppi_ex2(inputs)
	if (locale === "es") return es_ppi_ex2(inputs)
	if (locale === "de") return de_ppi_ex2(inputs)
	if (locale === "nl") return nl_ppi_ex2(inputs)
	if (locale === "fr") return fr_ppi_ex2(inputs)
	if (locale === "it") return it_ppi_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_ex2(inputs)
	if (locale === "pt") return pt_ppi_ex2(inputs)
	if (locale === "ja") return ja_ppi_ex2(inputs)
	return zh_ppi_ex2(inputs)
};